import { render, staticRenderFns } from "./ClassificationModal.vue?vue&type=template&id=636c0d40"
import script from "./ClassificationModal.vue?vue&type=script&lang=js"
export * from "./ClassificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports